import request from '@/utils/request'
//从环境变量获取auth服务的路径
const VUE_APP_AUTH_PATH = process.env.VUE_APP_AUTH_PATH

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
}

//定义异步的操作，即action
const actions = {
  // 生成二维码接口
  async generateQrCode({ commit }, params) {
        //发起request
        const url = `${VUE_APP_AUTH_PATH}/qr/generate/base64`
        const result = await request.get(url, { params });
        //获取服务返回数据
        return result
    },
    //扫码后调用（验证用户并更新状态）
    async verifyQrCheck({ commit }, params) {
        //发起request
        const url = `${VUE_APP_AUTH_PATH}/qr/check`
        const result = await request.get(url, { params });
        //获取服务返回数据
        return result
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }